
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-time-client-offer",
      function () {
        return require("private-next-pages/first-time-client-offer.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-time-client-offer"])
      });
    }
  